module.exports = __webpack_public_path__ + "img/fish.8a333e82.svg";